import { useCallback } from 'react';
import { PolicyTemplate } from '../../../../types/policies';
import { usePost, UsePostParams } from '../../../../api';
import { TEMPLATES_BASE_URL } from '../consts';

interface DuplicatePolicyParams {
    templateName: string;
}

export interface DuplicatePolicyResponse {
    originalId: PolicyTemplate['id'];
    duplicatedId: PolicyTemplate['id'];
    name: string;
}

interface DuplicateTemplateErrorResponse {
    templateId: PolicyTemplate['id'];
    error: string;
}

export type UseDuplicatePolicyTemplateParams = UsePostParams<
    DuplicatePolicyParams,
    DuplicatePolicyResponse,
    DuplicateTemplateErrorResponse
>;

export const useDuplicatePolicyTemplate = (params: UseDuplicatePolicyTemplateParams) => {
    const { post, loading, error } = usePost<
        Partial<DuplicatePolicyParams>,
        DuplicatePolicyResponse,
        DuplicateTemplateErrorResponse
    >(params);

    const duplicatePolicyTemplate = useCallback(
        (templateId: PolicyTemplate['id'], templateName: string) =>
            post(`${TEMPLATES_BASE_URL}/${templateId}/duplicate`, {
                templateName
            }),
        [post]
    );

    return {
        loading,
        error,
        duplicatePolicyTemplate
    };
};
